// src/SubsanacionNotificacion.js — JCUMAS 060.013
import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const BASE_URL = process.env.REACT_APP_API_URL;

const SubsanacionNotificacion = ({ notificacion, onSubsanada, onClose }) => {
  const [archivo, setArchivo] = useState(null);
  const [nombreArchivo, setNombreArchivo] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setNombreArchivo(file.name);
    const reader = new FileReader();
    reader.onload = () => {
      setArchivo(reader.result.split(",")[1]);
    };
    reader.readAsDataURL(file);
  };

  const enviarSubsanacion = async () => {
    if (!archivo) {
      setError("Selecciona un archivo antes de continuar.");
      return;
    }
    setEnviando(true);
    setError("");
    try {
      const now = new Date();
      const fechaHora = now.toISOString().split("T").join(" ").split("Z")[0];
      const res = await fetch(
        `${BASE_URL}/notificaciones/${notificacion.NotificacionID}/subsanacion`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            NombreDocumento: nombreArchivo,
            Documento: archivo,
            FechaSubida: fechaHora,
          }),
        }
      );
      if (res.ok) {
        alert("Documentación enviada correctamente.");
        onSubsanada();
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.error || "No se pudo enviar la documentación.");
      }
    } catch (e) {
      setError("No se pudo conectar con el servidor.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Modal show centered onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Aportar documentación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Esta notificación requiere que aportes documentación adicional para
          subsanar tu solicitud.
        </p>
        <Form.Group controlId="archivoSubsanacion">
          <Form.Label>Selecciona el documento (PDF)</Form.Label>
          <Form.Control type="file" accept=".pdf" onChange={handleFileChange} />
        </Form.Group>
        {error && <p className="text-danger small mt-2">{error}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={enviando}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={enviarSubsanacion} disabled={enviando || !archivo}>
          {enviando ? <Spinner animation="border" size="sm" /> : "Enviar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubsanacionNotificacion;
